import { call, put, takeEvery } from 'redux-saga/effects';
import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { SearchActionTypes } from 'app/modules/search/models';

// Api
import { txnEventsSearch as txnEventsSearchApi } from 'app/shared/api/search';

// Actions
import {
  txnEventsSearch as txnEventsSearchAction,
  txnEventsSearchSuccess,
} from 'app/modules/search/actions';

const rootAction = SearchActionTypes.TXN_EVENTS_SEARCH;
function* txnEventsSearch(
  payload: ReturnType<typeof txnEventsSearchAction>['payload'],
) {
  const config = {
    rootAction,
    request: call(txnEventsSearchApi, payload),
    errorToastMessage: `There was an error searching events. Please try again`,
    success: function* onSuccess(
      result: ReturnType<typeof txnEventsSearchSuccess>['payload'],
    ) {
      yield put(txnEventsSearchSuccess(result));
    },
  };
  yield call(makeSagaRequest, config);
}

function* txnEventsSearchFlow({
  payload,
}: ReturnType<typeof txnEventsSearchAction>) {
  yield call(txnEventsSearch, payload);
}

export default function* watchTxnEventsSearch() {
  yield takeEvery(rootAction, txnEventsSearchFlow);
}
